
// #region imports

// #region vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
// #endregion

// #region services
import DepartmentService from '@/services/department.service'
// #endregion

// #region interfaces
import { DepartmentInterface } from '@/types/interfaces/department'
import { AddressInterface } from '@/types/interfaces/address'
import { PublicBookingCustomVisualSettingsInterface } from '@/types/interfaces/setting'
// #endregion

// #endregion

@Component
export default class BookDepartmentCard extends Vue {
  @Prop({ default: false }) readonly row!: boolean
  @Prop({ required: false }) readonly backed!: boolean
  @Prop({ default: true }) readonly arrowRight!: boolean
  @Prop({ required: true }) readonly companyId!: string
  @Prop({ default: false })
  readonly visualSettings!: PublicBookingCustomVisualSettingsInterface

  departments = [] as Array<DepartmentInterface>

  async fetchAllDepartments (): Promise<void> {
    const result = await DepartmentService.getAllCompanyDepartmentsPublic(
      this.companyId
    )
    this.departments = result
  }

  @Watch('departments')
  async onDepartmentsChange (): Promise<void> {
    if (this.departments.length === 1 && !this.backed) {
      this.$emit('selectedDepartment', this.departments[0])
    }
    this.$emit('isOnlyOneDepartmentEvent', this.isOnlyOneDepartment)
  }

  async created (): Promise<void> {
    await this.fetchAllDepartments()
  }

  get isOnlyOneDepartment (): boolean {
    return this.departments.length === 1
  }

  formatFullAddress (address: AddressInterface | undefined): string {
    if (!address) return ''
    return `${address.address}, ${address.city}, ${address.zip}`
  }
}
